import { get } from '@kit/utils/APIV1.js'

export const page = async() => {
  return get(`contact-us-page`)
}